import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './services/auth.service';

const guardFn: CanActivateFn & CanActivateChildFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.usuario) return true;

  return auth.verificarSessao().pipe(
    map((logado) => (logado ? true : loginComRetorno(router))),
  );
};

export const PARAM_VOLTAR_PARA = 'voltarPara';

/** Leva ao login guardando a URL pedida, para o link do WhatsApp abrir o documento depois de entrar. */
export function loginComRetorno(router: Router): UrlTree {
  // Dentro de um guard vale a navegação em curso; num 401 no meio do uso, a tela atual.
  const url = router.currentNavigation()?.extractedUrl.toString() ?? router.url;

  return router.createUrlTree(['/login'], {
    queryParams: url && url !== '/' && !url.startsWith('/login') ? { [PARAM_VOLTAR_PARA]: url } : {},
  });
}

export const authGuard: CanActivateFn & CanActivateChildFn = guardFn;
